var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-good-table',{staticStyle:{"width":"100%"},attrs:{"columns":_vm.columns,"rows":_vm.zeroStateRows,"styleClass":"vgt-table striped","row-style-class":"blur-row"}},[_c('template',{slot:"emptystate"},[_c('span',[_vm._v("\n        There are not items to display\n      ")])])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }